import { Injectable, inject } from "@angular/core";
import { OidcClientService } from "@upmc-healthplan-npm/oidc-client";
import pako from 'pako';

@Injectable({ providedIn: 'root' })
export class SsoRedirectorService {
  oidc = inject(OidcClientService);

  ssoSamlOutBound(idpUrl: string, serviceUrl: string, samlIssuerValue: string, relayState?: string) {
    const samlBody = `<samlp:AuthnRequest xmlns:saml="urn:oasis:names:tc:SAML:2.0:assertion" ID="id${this.randomGuid()}" Version="2.0" IssueInstant="${+new Date()}" IsPassive="false" AssertionConsumerServiceURL="${serviceUrl}" xmlns:samlp="urn:oasis:names:tc:SAML:2.0:protocol">
    <saml:Issuer>${samlIssuerValue}</saml:Issuer>
    </samlp:AuthnRequest>`;
    const pakodeflate = pako.deflateRaw(samlBody, { to: 'string' });
    const btoaval = btoa(pakodeflate);
    const SAMLRequest = encodeURIComponent(btoaval);
    let ssoUrl = `${idpUrl}?SAMLRequest=${SAMLRequest}`;

    if (relayState) {
      ssoUrl += `&RelayState=${relayState}`;
    }

    window.open(ssoUrl);
  }

  private s4(): string {
    return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
  }

  randomGuid(length: number = 5): string {
    let uuid = '';

    for (let index = 0; index < length; index++) {
      uuid += this.s4();
    }

    return uuid;
  }
}
